var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[(_vm.$layout.currentPage)?_c(_vm.$layout.currentPage.pageComponentName,{tag:"component",attrs:{"record":_vm.$layout.currentPage}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }